import { createAsyncThunk } from "@reduxjs/toolkit";
import { logoutUser } from "./authThunks";

const API_BASE = process.env.REACT_APP_API_BASE;
const API_KEY = process.env.REACT_APP_API_KEY;
/**
 * fetch all favourites entries
 */
export const fetchFavouriteVendorsItems = createAsyncThunk(
  "favouriteVendors/fetchItems",
  async (_, thunkAPI) => {
    const res = await fetch(`${API_BASE}/api/favoritevendors`, {
      method: "GET",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        "x-user-role": "partner",
      },
    });

    // if (res.status === 401) {
    //   thunkAPI.dispatch(logoutUser());
    //   window.location.href = process.env.REACT_APP_AUTH_BASE_URL;
    //   return thunkAPI.rejectWithValue("Unauthorized");
    // }
    const json = await res.json();
    if (!res) {
      throw new Error(json?.message || "Fetch failed");
    }
    return json;
  }
);


export const createFavouriteVendorItem = createAsyncThunk(
  "favouriteVendors/createItem",
  async (data, { rejectWithValue }, thunkAPI) => {
    try {
      const res = await fetch(`${API_BASE}/api/favoritevendors`, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          "x-user-role": "partner",
        },
        body: JSON.stringify(data),
      });
      if (res.status === 401) {
        thunkAPI.dispatch(logoutUser());
        const currentUrl = window.location.href;
        const authUrl = `${process.env.REACT_APP_AUTH_BASE_URL}?redirect=${encodeURIComponent(currentUrl)}`;
        window.location.href = authUrl;
        return thunkAPI.rejectWithValue("Unauthorized");
      }
      const json = await res.json();

      if (!res.ok) {
        throw new Error(json?.message || "Create failed");
      }

      return json;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const removeFavouriteVendor = createAsyncThunk(
  "favouriteVendors/removeItem",
  async (vendorId, { rejectWithValue }, thunkAPI) => {
    try {
      const res = await fetch(`${API_BASE}/api/favoritevendors/${vendorId}`, {
        method: "DELETE",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          "x-user-role": "partner",
        },
      });
      if (res.status === 401) {
        thunkAPI.dispatch(logoutUser());
        const currentUrl = window.location.href;
        const authUrl = `${process.env.REACT_APP_AUTH_BASE_URL}?redirect=${encodeURIComponent(currentUrl)}`;
        window.location.href = authUrl;
        return thunkAPI.rejectWithValue("Unauthorized");
      }
      const json = await res.json();

      if (!res.ok) {
        throw new Error(json?.message || "Create failed");
      }

      return json;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);